import { render, staticRenderFns } from "./PopularStreamsMenu.vue?vue&type=template&id=51a081bf&"
import script from "./popularStreamsMenu.js?vue&type=script&lang=js&"
export * from "./popularStreamsMenu.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports